import instance_api from "../../config/axiosConfig";
import {getOtSkills, getOvertimeCallsheet, addOTShiftAPI, duplicateCheckOTShift, resolveOTWbFailed, callLogAPI, otSignupsAPI, getVotReport, addOTShiftStatus } from "../../constants/constants";

class OvertimeAPI {
    
    constructor(name) {
        this.name = name;
    }

    getOTSkillsData(station='') {
        return instance_api("GET", getOtSkills(station));
    }
    
    getCallsheet({ empId ='', otGroup='', schedBidGroup='', volOtDate='', station='', shiftsReqs=[], sessionToken='', department='', isCurrentCompleted=false }) {
        const data = {
            empId,
            otGroup,
            schedBidGroup,
            volOtDate,
            station,
            shiftsReqs,
            sessionToken,
            department,
            isCurrentCompleted
        };
        return instance_api('POST', getOvertimeCallsheet(), data);
    }

    addOTShift(data) {
        return instance_api('POST', addOTShiftAPI(), data);
    }

    checkDuplicateShift(data) {
        return instance_api('POST', duplicateCheckOTShift(), data);
    }

    resolveWbFailed(data) {
        return instance_api('POST', resolveOTWbFailed(), data);
    }

    getVotReport({ station = '', department = '', date = '' }) {
        return instance_api('GET', getVotReport(station, department, date));
    }

    postCallLog({ callType='', isAnswered=false, isCallReturned=false, action='', createdBy='', callNotes='', empId='', votRequestId='', shiftType='', startTime='', endTime='', workLocation='', wbFailureResolveAction='', wbFailureResolveComments='', station='', lastUpdated='', sessionToken=''}) {
        const data={
            callType,
            isAnswered,
            isCallReturned,
            action,
            createdBy,
            callNotes,
            empId,
            votRequestId,
            shiftType,
            startTime,
            endTime,
            workLocation,
            wbFailureResolveAction,
            wbFailureResolveComments,
            station,
            lastUpdated,
            sessionToken
        }
        return instance_api('POST', callLogAPI(), data);
    }

    getCallLog({ votId, empId }) {
        const url = `${callLogAPI()}?votRequestId=${encodeURIComponent(votId)}&empId=${encodeURIComponent(empId)}`;
        return instance_api('GET', url);
    }

    checkOTShiftStatus(reqIds) {
        return instance_api('GET', `${addOTShiftStatus()}?reqIds=${reqIds}`);
    }

    getOtSignups({ empId = '', station = '', otGroup = '', schedBidGroup = '', volOtDate = '', sessionToken = '' }) {
        const data = { empId, station, otGroup, schedBidGroup, volOtDate, sessionToken };
        return instance_api('POST', otSignupsAPI(), data);
    }
}

export const {
    getOTSkillsData,
    getCallsheet,
    addOTShift,
    checkDuplicateShift,
    resolveWbFailed,
    getVotReport: getVotReportData,
    postCallLog,
    getCallLog,
    checkOTShiftStatus,
    getOtSignups
} = new OvertimeAPI("instance");
